/**
 * Banner listing pack rows that could not be traced back to the catalog
 * when a saved draft was reopened (see packHydrate.js).
 *
 * This is a real warning, not a nicety: saving the wizard re-runs the
 * select-* composer, which wipes and rewrites the pack's template rows.
 * Anything listed here is absent from the pickers, so it will be dropped
 * on save unless the operator re-picks it by hand.
 */
import { AlertTriangle } from "lucide-react";

export default function UnmatchedNotice({ items }) {
  if (!items || items.length === 0) return null;
  const shown = items.slice(0, 12);
  const rest = items.length - shown.length;
  return (
    <div className="rounded-md border border-amber-500/40 bg-amber-500/10 px-3 py-2.5 text-sm text-amber-200">
      <div className="flex items-start gap-2">
        <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" />
        <div className="min-w-0">
          <div className="font-medium">
            {items.length} row{items.length === 1 ? "" : "s"} could not be
            matched back to the catalog
          </div>
          <p className="text-xs text-amber-200/80 mt-1 leading-relaxed">
            These were in the saved draft but the catalog row they came from
            can no longer be identified (renamed, removed, or a duplicate
            name). They are <strong>not</strong> selected below — saving will
            drop them unless you re-pick them.
          </p>
          <ul className="mt-2 text-xs font-mono space-y-0.5">
            {shown.map((label, i) => (
              <li key={`${label}-${i}`} className="truncate">· {label}</li>
            ))}
            {rest > 0 && (
              <li className="opacity-70">· … and {rest} more</li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}
